import {Identity} from 'api/types/properties'
import {IdentityModalTypes} from 'actions/modal/types'
import IdentityModalView from './IdentityModalView'
import {NinchatErrorType} from 'api/types/errors'
import {NinchatEvents} from 'api/types'
import React from 'react'
import {createIdentity} from 'api/action/createIdentity'
import {deleteIdentity} from 'api/action/deleteIdentity'
import {identityModal} from 'actions/modal'
import {toast} from 'components/Toast'
import {updateIdentityAuth} from 'api/action/updateIdentityAuth'
import {useAppDispatch} from 'hooks'
import {useTranslation} from 'react-i18next'


interface IdentityModalProps {
    identity: Identity
    type: IdentityModalTypes
}

const IdentityModal = (props: IdentityModalProps): React.ReactElement => {
    const {
        identity, type,
    } = props
    const dispatch = useAppDispatch()
    const {t} = useTranslation()


    const closeModal = () => {
        dispatch(identityModal({show: false}))
    }

    const handleCancel = () => {
        closeModal()
    }

    const handleClose = () => {
        closeModal()
    }

    const removeIdentity = (password: string) => {
        dispatch(deleteIdentity({
            identity_auth: password,
            identity_name: identity.name,
            identity_type: identity.type,
        })).unwrap()
            .then(
                () => {
                    toast.success(t('Identity deleted'))
                    closeModal()
                },
                (error: NinchatEvents.NinchatErrorEvent) => {
                    if (error.error_type === NinchatErrorType.NinchatAccessDeniedError) {
                        toast.error(t('Invalid password'))
                    } else {
                        toast.error(t('Error removing identity'))
                    }
                },
            )
    }

    const addIdentity = (email: string, password: string) => {
        dispatch(createIdentity({
            identity_auth_new: password,
            identity_name: email,
            identity_type: 'email',
        })).unwrap()
            .then(
                () => {
                    toast.success(t('Identity created'))
                    closeModal()
                },
                (error: NinchatEvents.NinchatErrorEvent) => {
                    if (error.error_type === NinchatErrorType.NinchatIdentityAlreadyExistsError) {
                        toast.error('Email already exists')
                    } else {
                        toast.error(t('Error creating identity'))
                    }
                },
            )
    }

    const changeIdentityPassword = (password: string, newPassword: string) => {
        dispatch(updateIdentityAuth({
            identity_auth: password,
            identity_auth_new: newPassword,
            identity_name: identity.name,
            identity_type: identity.type,
        })).unwrap()
            .then(
                () => {
                    toast.success(t('Password changed'))
                    closeModal()
                },
                (error: NinchatEvents.NinchatErrorEvent) => {
                    if (error.error_type === NinchatErrorType.NinchatAccessDeniedError) {
                        toast.error(t('Invalid password'))
                    } else {
                        toast.error(t('Error changing password'))
                    }
                },
            )
    }

    const handleAction = ({
        password, newPassword, email,
    }: {
        password?: string;
        newPassword?: string;
        email?: string
    }) => {
        if (type === IdentityModalTypes.remove && password) {
            removeIdentity(password)
        } else if (type === IdentityModalTypes.add && email && newPassword) {
            addIdentity(email, newPassword)
        } else if (type === IdentityModalTypes.changePassword && password && newPassword) {
            changeIdentityPassword(password, newPassword)
        }
    }

    return (
        <IdentityModalView
            handleAction={handleAction}
            handleCancel={handleCancel}
            handleClose={handleClose}
            identity={identity}
            type={type}
        />
    )
}

export default IdentityModal
